import { render, staticRenderFns } from "./StSearch.vue?vue&type=template&id=5c704d46"
import script from "./StSearch.vue?vue&type=script&lang=js"
export * from "./StSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports